module.exports = __webpack_public_path__ + "static/media/attach.42362f5f.svg";